import React, { useEffect } from 'react';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { useHistory } from 'react-router-dom';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import Grid from '@material-ui/core/Grid';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ApiService from '../../services/ApiService';
import { setTicketNumber } from '../HomePage/ContentTabs/ContentTabsSlice';
import FilterNotificationPopUp from './FilterNotificationPopUp';
import {
  setEditedTicket,
  setValidationErrorsMultiLang,
} from '../EditTicket/EditTicketSlice';
import {
  selectedBusinessUnitsState,
  userInfoState,
} from '../HomePage/HomeSlice';

import useStyles from './styles';
import i18n from '../../i18n';

export default function NotificationsPage(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { initialAnchorEl, notifications } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [openFilter, setOpenFilter] = React.useState(false);

  const lang = i18n.language;
  const history = useHistory();
  const selectedBusinessUnits = useSelector(selectedBusinessUnitsState);
  const [fetchedNotifications, setFetchedNotifications] = React.useState([]);
  const user = useSelector(userInfoState);

  useEffect(() => {
    setFetchedNotifications(notifications);
  }, [notifications]);
  useEffect(() => {
    setAnchorEl(initialAnchorEl);
    setOpen(Boolean(initialAnchorEl));
  }, [initialAnchorEl]);

  const handleClickAway = () => {
    if (!openFilter) {
      setOpen(false);
      setAnchorEl(null);
      props.sendAnchorEl();
    }
  };
  async function getTicketDetails(ticketNumber) {
    const result = await ApiService.getTicketDetails(ticketNumber);
    dispatch(setTicketNumber(result.data.ticket.ticketNumber));
    dispatch(setEditedTicket(result.data.ticket));
    dispatch(setValidationErrorsMultiLang(result.data.validationErrors));
    history.push(`/ticket/details/${ticketNumber}`);
  }

  function isCurrentDay(notificationDate) {
    return (
      new Date().getDate() === new Date(notificationDate).getDate() &&
      new Date().getMonth() === new Date(notificationDate).getMonth() &&
      new Date().getFullYear() === new Date(notificationDate).getFullYear()
    );
  }
  function closeFilterPopUp() {
    setOpenFilter(false);
  }
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Popper
        open={open}
        anchorEl={anchorEl}
        className={
          fetchedNotifications.length > 0
            ? classes.popperStyle
            : classes.emptyPopperStyle
        }
        placement="bottom-end"
      >
        {fetchedNotifications.length > 0 && (
          <Paper className={classes.paperPopper}>
            <Grid
              container
              spacing={0}
              className={classes.grid}
              align="center"
              justify="center"
            >
              <Grid item xs={10}>
                <Typography className={classes.title}>
                  {t('notifications')}
                </Typography>{' '}
              </Grid>

              <Grid item xs={2}>
                {(user.hasAllRights || user.hasEmilyDRights) && (
                  <FilterListIcon
                    className={
                      selectedBusinessUnits != null
                        ? classes.redFilterIcon
                        : classes.filterIcon
                    }
                    onClick={() => {
                      setOpenFilter(true);
                    }}
                  />
                )}
              </Grid>
            </Grid>
            <Divider />

            <List>
              {fetchedNotifications.map((notification, index) => {
                const notificationId = `notification-${index}`;
                return (
                  <div key={notificationId}>
                    <ListItem
                      button
                      className={classes.listItem}
                      onClick={() => {
                        getTicketDetails(notification.ticketNumber);
                      }}
                    >
                      <ListItemIcon className={classes.listItemIcon}>
                        <FiberManualRecordIcon className={classes.bulletIcon} />
                      </ListItemIcon>
                      <ListItemText>
                        <Grid container spacing={0}>
                          <Grid item xs={10}>
                            <Typography className={classes.listItemText}>
                              {lang === 'en'
                                ? notification.messageEN
                                : lang === 'fr'
                                ? notification.messageFR
                                : notification.messageDE}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            container
                            justify="flex-end"
                            alignItems="center"
                          >
                            <CheckCircleRoundedIcon
                              className={
                                isCurrentDay(notification.notificationDate)
                                  ? classes.activeCheckButton
                                  : classes.disabledCheckButton
                              }
                            />
                          </Grid>
                        </Grid>
                      </ListItemText>
                    </ListItem>

                    <Divider />
                  </div>
                );
              })}
            </List>
            <div />
          </Paper>
        )}
        <FilterNotificationPopUp
          open={openFilter}
          setOpenFilterState={closeFilterPopUp}
        />
      </Popper>
    </ClickAwayListener>
  );
}
